import { memo } from "react";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

import ServiceConnectionStep from "components/ServiceConnectionStep";

// -----------------------------------------------------------------------------

const EnablingRequisiteScopesPhase = memo(
  function EnablingRequisiteScopesPhase({
    disabled,
    progressIcon,
    successIcon,
    errorIcon,
  }: EnablingRequisiteScopesPhaseProps): JSX.Element {
    return (
      <ServiceConnectionStep disabled={disabled}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {progressIcon ? (
            <CircularProgress size="24px" sx={{ mr: 1 }} />
          ) : null}
          {successIcon ? (
            <CheckCircleOutlineRoundedIcon color="success" sx={{ mr: 1 }} />
          ) : null}
          {errorIcon ? (
            <ErrorOutlineRoundedIcon color="error" sx={{ mr: 1 }} />
          ) : null}
          <Typography variant="body1">Checking enabled scopes</Typography>
        </Box>
        <Stack sx={{ mt: 2 }} spacing={1} direction="column">
          <Typography variant="body1">
            We&apos;re enabling the required scopes in your Google Cloud
            Platform account.
          </Typography>
        </Stack>
      </ServiceConnectionStep>
    );
  }
);

export default EnablingRequisiteScopesPhase;

// -----------------------------------------------------------------------------

interface EnablingRequisiteScopesPhaseProps {
  disabled: boolean;
  progressIcon: boolean;
  successIcon: boolean;
  errorIcon: boolean;
}
